/* eslint-disable react/require-default-props */
import { useState } from 'react';

import { IconCancelMS, IconDeleteMS } from '../../constants/icons';
import {
  AlertTypography,
  ButtonBox,
  DialogButton,
  DialogContainer,
  FilledButton,
  OutlinedButton,
  StyledDialog,
  TextTypography,
} from './styles';

interface ConfirmationDialogProps {
  title: string | JSX.Element;
  text: string;
  modalCallback: () => void;
  iconDelete?: boolean;
  iconCancel?: boolean;
}

export default function ConfirmationDeleteDialog({
  title,
  text,
  modalCallback,
  iconDelete,
  iconCancel,
}: ConfirmationDialogProps): JSX.Element {
  const [open, setOpen] = useState(false);

  const handleOpen = (): void => setOpen(true);
  const handleClose = (): void => setOpen(false);

  const handleConfirm = (): void => {
    modalCallback();
    handleClose();
  };

  return (
    <>
      <DialogButton onClick={handleOpen}>
        {iconDelete && IconDeleteMS}
        {iconCancel && IconCancelMS}
        {title}
      </DialogButton>
      <StyledDialog
        open={open}
        onClose={handleClose}
        aria-labelledby="confirmation dialog"
      >
        <DialogContainer>
          <TextTypography>Você gostaria de {text}?</TextTypography>
          <ButtonBox>
            <OutlinedButton onClick={handleClose}>Não</OutlinedButton>
            <FilledButton onClick={handleConfirm}>Sim</FilledButton>
          </ButtonBox>
          <AlertTypography>
            Atenção! Esta ação não poderá ser desfeita.
          </AlertTypography>
        </DialogContainer>
      </StyledDialog>
    </>
  );
}
